// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/offboarding/v1/offboarding.proto" (package "c1.api.offboarding.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingSearchRequest
 */
export interface OffboardingSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string offboarding_ticket_ids = 2
     */
    offboardingTicketIds: string[];
    /**
     * @generated from protobuf field: repeated string app_user_ids = 3
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: repeated string app_ids = 4
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string app_entitlement_ids = 5
     */
    appEntitlementIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.offboarding.v1.OffboardingTrackerOutcome outcomes = 6
     */
    outcomes: OffboardingTrackerOutcome[];
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerExpandMask expand_mask = 7
     */
    expandMask?: OffboardingTrackerExpandMask;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 9
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.offboarding.v1.OffboardingTrackerRef refs = 10
     */
    refs: OffboardingTrackerRef[];
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingSearchResponse
 */
export interface OffboardingSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.offboarding.v1.OffboardingTrackerView list = 1
     */
    list: OffboardingTrackerView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.MutateOffboardingTrackerRequest
 */
export interface MutateOffboardingTrackerRequest {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome outcome = 5
     */
    outcome?: OffboardingTrackerOutcome;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.MutateOffboardingTrackerResponse
 */
export interface MutateOffboardingTrackerResponse {
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTracker offboarding_tracker = 1
     */
    offboardingTracker?: OffboardingTracker;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.GetOffboardingTrackerResponse
 */
export interface GetOffboardingTrackerResponse {
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTracker offboarding_tracker = 1
     */
    offboardingTracker?: OffboardingTracker;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.GetOffboardingTrackerRequest
 */
export interface GetOffboardingTrackerRequest {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.ListOffboardingTrackersRequest
 */
export interface ListOffboardingTrackersRequest {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerExpandMask expand_mask = 4
     */
    expandMask?: OffboardingTrackerExpandMask;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.ListOffboardingTrackersResponse
 */
export interface ListOffboardingTrackersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.offboarding.v1.OffboardingTrackerView list = 1
     */
    list: OffboardingTrackerView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTracker
 */
export interface OffboardingTracker {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome outcome = 7
     */
    outcome?: OffboardingTrackerOutcome;
    /**
     * @generated from protobuf field: string app_entitlement_id = 8
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string tenant_id = 9
     */
    tenantId: string;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerExpandMask
 */
export interface OffboardingTrackerExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerView
 */
export interface OffboardingTrackerView {
    /**
     * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTracker offboarding_tracker = 1
     */
    offboardingTracker?: OffboardingTracker;
    /**
     * @generated from protobuf field: string offboarding_ticket_id_path = 2
     */
    offboardingTicketIdPath: string;
    /**
     * @generated from protobuf field: string app_id_path = 3
     */
    appIdPath: string;
    /**
     * @generated from protobuf field: string app_user_id_path = 4
     */
    appUserIdPath: string;
    /**
     * @generated from protobuf field: string actor_id_path = 5
     */
    actorIdPath: string;
    /**
     * @generated from protobuf field: string outcome_path = 6
     */
    outcomePath: string;
    /**
     * @generated from protobuf field: string app_entitlement_id_path = 7
     */
    appEntitlementIdPath: string;
}
/**
 * Putting this in it's own message makes swith statements a lot easier
 *
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome
 */
export interface OffboardingTrackerOutcome {
    /**
     * @generated from protobuf field: string actor_id = 1
     */
    actorId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp outcome_time = 2
     */
    outcomeTime?: Timestamp;
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "revoke";
        /**
         * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke revoke = 101
         */
        revoke: OffboardingTrackerOutcome_Revoke;
    } | {
        oneofKind: "ignore";
        /**
         * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore ignore = 201
         */
        ignore: OffboardingTrackerOutcome_Ignore;
    } | {
        oneofKind: "relatedObjectDeleted";
        /**
         * @generated from protobuf field: c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted related_object_deleted = 301
         */
        relatedObjectDeleted: OffboardingTrackerOutcome_RelatedObjectDeleted;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke
 */
export interface OffboardingTrackerOutcome_Revoke {
    /**
     * @generated from protobuf field: string ticket_id = 1
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore
 */
export interface OffboardingTrackerOutcome_Ignore {
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted
 */
export interface OffboardingTrackerOutcome_RelatedObjectDeleted {
}
/**
 * @generated from protobuf message c1.api.offboarding.v1.OffboardingTrackerRef
 */
export interface OffboardingTrackerRef {
    /**
     * @generated from protobuf field: string offboarding_ticket_id = 1
     */
    offboardingTicketId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4
     */
    appUserId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingSearchRequest$Type extends MessageType<OffboardingSearchRequest> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "offboarding_ticket_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "outcomes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OffboardingTrackerOutcome },
            { no: 7, name: "expand_mask", kind: "message", T: () => OffboardingTrackerExpandMask },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 9, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 10, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OffboardingTrackerRef }
        ]);
    }
    create(value?: PartialMessage<OffboardingSearchRequest>): OffboardingSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.offboardingTicketIds = [];
        message.appUserIds = [];
        message.appIds = [];
        message.appEntitlementIds = [];
        message.outcomes = [];
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<OffboardingSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingSearchRequest): OffboardingSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated string offboarding_ticket_ids */ 2:
                    message.offboardingTicketIds.push(reader.string());
                    break;
                case /* repeated string app_user_ids */ 3:
                    message.appUserIds.push(reader.string());
                    break;
                case /* repeated string app_ids */ 4:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated string app_entitlement_ids */ 5:
                    message.appEntitlementIds.push(reader.string());
                    break;
                case /* repeated c1.api.offboarding.v1.OffboardingTrackerOutcome outcomes */ 6:
                    message.outcomes.push(OffboardingTrackerOutcome.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.offboarding.v1.OffboardingTrackerExpandMask expand_mask */ 7:
                    message.expandMask = OffboardingTrackerExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 9:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.offboarding.v1.OffboardingTrackerRef refs */ 10:
                    message.refs.push(OffboardingTrackerRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated string offboarding_ticket_ids = 2; */
        for (let i = 0; i < message.offboardingTicketIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.offboardingTicketIds[i]);
        /* repeated string app_user_ids = 3; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.appUserIds[i]);
        /* repeated string app_ids = 4; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated string app_entitlement_ids = 5; */
        for (let i = 0; i < message.appEntitlementIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appEntitlementIds[i]);
        /* repeated c1.api.offboarding.v1.OffboardingTrackerOutcome outcomes = 6; */
        for (let i = 0; i < message.outcomes.length; i++)
            OffboardingTrackerOutcome.internalBinaryWrite(message.outcomes[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.offboarding.v1.OffboardingTrackerExpandMask expand_mask = 7; */
        if (message.expandMask)
            OffboardingTrackerExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        /* string page_token = 9; */
        if (message.pageToken !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.offboarding.v1.OffboardingTrackerRef refs = 10; */
        for (let i = 0; i < message.refs.length; i++)
            OffboardingTrackerRef.internalBinaryWrite(message.refs[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingSearchRequest
 */
export const OffboardingSearchRequest = new OffboardingSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingSearchResponse$Type extends MessageType<OffboardingSearchResponse> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OffboardingTrackerView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<OffboardingSearchResponse>): OffboardingSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<OffboardingSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingSearchResponse): OffboardingSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.offboarding.v1.OffboardingTrackerView list */ 1:
                    message.list.push(OffboardingTrackerView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.offboarding.v1.OffboardingTrackerView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            OffboardingTrackerView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingSearchResponse
 */
export const OffboardingSearchResponse = new OffboardingSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutateOffboardingTrackerRequest$Type extends MessageType<MutateOffboardingTrackerRequest> {
    constructor() {
        super("c1.api.offboarding.v1.MutateOffboardingTrackerRequest", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "outcome", kind: "message", T: () => OffboardingTrackerOutcome }
        ]);
    }
    create(value?: PartialMessage<MutateOffboardingTrackerRequest>): MutateOffboardingTrackerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offboardingTicketId = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<MutateOffboardingTrackerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MutateOffboardingTrackerRequest): MutateOffboardingTrackerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string offboarding_ticket_id */ 1:
                    message.offboardingTicketId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 4:
                    message.appUserId = reader.string();
                    break;
                case /* c1.api.offboarding.v1.OffboardingTrackerOutcome outcome */ 5:
                    message.outcome = OffboardingTrackerOutcome.internalBinaryRead(reader, reader.uint32(), options, message.outcome);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MutateOffboardingTrackerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string offboarding_ticket_id = 1; */
        if (message.offboardingTicketId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.offboardingTicketId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 4; */
        if (message.appUserId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appUserId);
        /* c1.api.offboarding.v1.OffboardingTrackerOutcome outcome = 5; */
        if (message.outcome)
            OffboardingTrackerOutcome.internalBinaryWrite(message.outcome, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.MutateOffboardingTrackerRequest
 */
export const MutateOffboardingTrackerRequest = new MutateOffboardingTrackerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutateOffboardingTrackerResponse$Type extends MessageType<MutateOffboardingTrackerResponse> {
    constructor() {
        super("c1.api.offboarding.v1.MutateOffboardingTrackerResponse", [
            { no: 1, name: "offboarding_tracker", kind: "message", T: () => OffboardingTracker }
        ]);
    }
    create(value?: PartialMessage<MutateOffboardingTrackerResponse>): MutateOffboardingTrackerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<MutateOffboardingTrackerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MutateOffboardingTrackerResponse): MutateOffboardingTrackerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.offboarding.v1.OffboardingTracker offboarding_tracker */ 1:
                    message.offboardingTracker = OffboardingTracker.internalBinaryRead(reader, reader.uint32(), options, message.offboardingTracker);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MutateOffboardingTrackerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.offboarding.v1.OffboardingTracker offboarding_tracker = 1; */
        if (message.offboardingTracker)
            OffboardingTracker.internalBinaryWrite(message.offboardingTracker, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.MutateOffboardingTrackerResponse
 */
export const MutateOffboardingTrackerResponse = new MutateOffboardingTrackerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOffboardingTrackerResponse$Type extends MessageType<GetOffboardingTrackerResponse> {
    constructor() {
        super("c1.api.offboarding.v1.GetOffboardingTrackerResponse", [
            { no: 1, name: "offboarding_tracker", kind: "message", T: () => OffboardingTracker }
        ]);
    }
    create(value?: PartialMessage<GetOffboardingTrackerResponse>): GetOffboardingTrackerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetOffboardingTrackerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOffboardingTrackerResponse): GetOffboardingTrackerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.offboarding.v1.OffboardingTracker offboarding_tracker */ 1:
                    message.offboardingTracker = OffboardingTracker.internalBinaryRead(reader, reader.uint32(), options, message.offboardingTracker);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOffboardingTrackerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.offboarding.v1.OffboardingTracker offboarding_tracker = 1; */
        if (message.offboardingTracker)
            OffboardingTracker.internalBinaryWrite(message.offboardingTracker, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.GetOffboardingTrackerResponse
 */
export const GetOffboardingTrackerResponse = new GetOffboardingTrackerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOffboardingTrackerRequest$Type extends MessageType<GetOffboardingTrackerRequest> {
    constructor() {
        super("c1.api.offboarding.v1.GetOffboardingTrackerRequest", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetOffboardingTrackerRequest>): GetOffboardingTrackerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offboardingTicketId = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<GetOffboardingTrackerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOffboardingTrackerRequest): GetOffboardingTrackerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string offboarding_ticket_id */ 1:
                    message.offboardingTicketId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 4:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOffboardingTrackerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string offboarding_ticket_id = 1; */
        if (message.offboardingTicketId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.offboardingTicketId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 4; */
        if (message.appUserId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.GetOffboardingTrackerRequest
 */
export const GetOffboardingTrackerRequest = new GetOffboardingTrackerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOffboardingTrackersRequest$Type extends MessageType<ListOffboardingTrackersRequest> {
    constructor() {
        super("c1.api.offboarding.v1.ListOffboardingTrackersRequest", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => OffboardingTrackerExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListOffboardingTrackersRequest>): ListOffboardingTrackersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offboardingTicketId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListOffboardingTrackersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOffboardingTrackersRequest): ListOffboardingTrackersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string offboarding_ticket_id */ 1:
                    message.offboardingTicketId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.offboarding.v1.OffboardingTrackerExpandMask expand_mask */ 4:
                    message.expandMask = OffboardingTrackerExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOffboardingTrackersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string offboarding_ticket_id = 1; */
        if (message.offboardingTicketId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.offboardingTicketId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.offboarding.v1.OffboardingTrackerExpandMask expand_mask = 4; */
        if (message.expandMask)
            OffboardingTrackerExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.ListOffboardingTrackersRequest
 */
export const ListOffboardingTrackersRequest = new ListOffboardingTrackersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOffboardingTrackersResponse$Type extends MessageType<ListOffboardingTrackersResponse> {
    constructor() {
        super("c1.api.offboarding.v1.ListOffboardingTrackersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OffboardingTrackerView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ListOffboardingTrackersResponse>): ListOffboardingTrackersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ListOffboardingTrackersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOffboardingTrackersResponse): ListOffboardingTrackersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.offboarding.v1.OffboardingTrackerView list */ 1:
                    message.list.push(OffboardingTrackerView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOffboardingTrackersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.offboarding.v1.OffboardingTrackerView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            OffboardingTrackerView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.ListOffboardingTrackersResponse
 */
export const ListOffboardingTrackersResponse = new ListOffboardingTrackersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTracker$Type extends MessageType<OffboardingTracker> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTracker", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "outcome", kind: "message", T: () => OffboardingTrackerOutcome },
            { no: 8, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OffboardingTracker>): OffboardingTracker {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offboardingTicketId = "";
        message.appId = "";
        message.appUserId = "";
        message.appEntitlementId = "";
        message.tenantId = "";
        if (value !== undefined)
            reflectionMergePartial<OffboardingTracker>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingTracker): OffboardingTracker {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string offboarding_ticket_id */ 1:
                    message.offboardingTicketId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.offboarding.v1.OffboardingTrackerOutcome outcome */ 7:
                    message.outcome = OffboardingTrackerOutcome.internalBinaryRead(reader, reader.uint32(), options, message.outcome);
                    break;
                case /* string app_entitlement_id */ 8:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string tenant_id */ 9:
                    message.tenantId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingTracker, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string offboarding_ticket_id = 1; */
        if (message.offboardingTicketId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.offboardingTicketId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.offboarding.v1.OffboardingTrackerOutcome outcome = 7; */
        if (message.outcome)
            OffboardingTrackerOutcome.internalBinaryWrite(message.outcome, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string app_entitlement_id = 8; */
        if (message.appEntitlementId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string tenant_id = 9; */
        if (message.tenantId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.tenantId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTracker
 */
export const OffboardingTracker = new OffboardingTracker$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerExpandMask$Type extends MessageType<OffboardingTrackerExpandMask> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "offboarding_ticket_id", "app_id", "app_user_id", "actor_id", "outcome", "app_entitlement_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<OffboardingTrackerExpandMask>): OffboardingTrackerExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<OffboardingTrackerExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingTrackerExpandMask): OffboardingTrackerExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingTrackerExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerExpandMask
 */
export const OffboardingTrackerExpandMask = new OffboardingTrackerExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerView$Type extends MessageType<OffboardingTrackerView> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerView", [
            { no: 1, name: "offboarding_tracker", kind: "message", T: () => OffboardingTracker },
            { no: 2, name: "offboarding_ticket_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "actor_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "outcome_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "app_entitlement_id_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OffboardingTrackerView>): OffboardingTrackerView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offboardingTicketIdPath = "";
        message.appIdPath = "";
        message.appUserIdPath = "";
        message.actorIdPath = "";
        message.outcomePath = "";
        message.appEntitlementIdPath = "";
        if (value !== undefined)
            reflectionMergePartial<OffboardingTrackerView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingTrackerView): OffboardingTrackerView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.offboarding.v1.OffboardingTracker offboarding_tracker */ 1:
                    message.offboardingTracker = OffboardingTracker.internalBinaryRead(reader, reader.uint32(), options, message.offboardingTracker);
                    break;
                case /* string offboarding_ticket_id_path */ 2:
                    message.offboardingTicketIdPath = reader.string();
                    break;
                case /* string app_id_path */ 3:
                    message.appIdPath = reader.string();
                    break;
                case /* string app_user_id_path */ 4:
                    message.appUserIdPath = reader.string();
                    break;
                case /* string actor_id_path */ 5:
                    message.actorIdPath = reader.string();
                    break;
                case /* string outcome_path */ 6:
                    message.outcomePath = reader.string();
                    break;
                case /* string app_entitlement_id_path */ 7:
                    message.appEntitlementIdPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingTrackerView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.offboarding.v1.OffboardingTracker offboarding_tracker = 1; */
        if (message.offboardingTracker)
            OffboardingTracker.internalBinaryWrite(message.offboardingTracker, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string offboarding_ticket_id_path = 2; */
        if (message.offboardingTicketIdPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.offboardingTicketIdPath);
        /* string app_id_path = 3; */
        if (message.appIdPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appIdPath);
        /* string app_user_id_path = 4; */
        if (message.appUserIdPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appUserIdPath);
        /* string actor_id_path = 5; */
        if (message.actorIdPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.actorIdPath);
        /* string outcome_path = 6; */
        if (message.outcomePath !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.outcomePath);
        /* string app_entitlement_id_path = 7; */
        if (message.appEntitlementIdPath !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.appEntitlementIdPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerView
 */
export const OffboardingTrackerView = new OffboardingTrackerView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerOutcome$Type extends MessageType<OffboardingTrackerOutcome> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerOutcome", [
            { no: 1, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "outcome_time", kind: "message", T: () => Timestamp },
            { no: 101, name: "revoke", kind: "message", oneof: "outcome", T: () => OffboardingTrackerOutcome_Revoke },
            { no: 201, name: "ignore", kind: "message", oneof: "outcome", T: () => OffboardingTrackerOutcome_Ignore },
            { no: 301, name: "related_object_deleted", kind: "message", oneof: "outcome", T: () => OffboardingTrackerOutcome_RelatedObjectDeleted }
        ]);
    }
    create(value?: PartialMessage<OffboardingTrackerOutcome>): OffboardingTrackerOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actorId = "";
        message.outcome = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<OffboardingTrackerOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingTrackerOutcome): OffboardingTrackerOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string actor_id */ 1:
                    message.actorId = reader.string();
                    break;
                case /* google.protobuf.Timestamp outcome_time */ 2:
                    message.outcomeTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.outcomeTime);
                    break;
                case /* c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke revoke */ 101:
                    message.outcome = {
                        oneofKind: "revoke",
                        revoke: OffboardingTrackerOutcome_Revoke.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).revoke)
                    };
                    break;
                case /* c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore ignore */ 201:
                    message.outcome = {
                        oneofKind: "ignore",
                        ignore: OffboardingTrackerOutcome_Ignore.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).ignore)
                    };
                    break;
                case /* c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted related_object_deleted */ 301:
                    message.outcome = {
                        oneofKind: "relatedObjectDeleted",
                        relatedObjectDeleted: OffboardingTrackerOutcome_RelatedObjectDeleted.internalBinaryRead(reader, reader.uint32(), options, (message.outcome as any).relatedObjectDeleted)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingTrackerOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string actor_id = 1; */
        if (message.actorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.actorId);
        /* google.protobuf.Timestamp outcome_time = 2; */
        if (message.outcomeTime)
            Timestamp.internalBinaryWrite(message.outcomeTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke revoke = 101; */
        if (message.outcome.oneofKind === "revoke")
            OffboardingTrackerOutcome_Revoke.internalBinaryWrite(message.outcome.revoke, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore ignore = 201; */
        if (message.outcome.oneofKind === "ignore")
            OffboardingTrackerOutcome_Ignore.internalBinaryWrite(message.outcome.ignore, writer.tag(201, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted related_object_deleted = 301; */
        if (message.outcome.oneofKind === "relatedObjectDeleted")
            OffboardingTrackerOutcome_RelatedObjectDeleted.internalBinaryWrite(message.outcome.relatedObjectDeleted, writer.tag(301, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome
 */
export const OffboardingTrackerOutcome = new OffboardingTrackerOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerOutcome_Revoke$Type extends MessageType<OffboardingTrackerOutcome_Revoke> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke", [
            { no: 1, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OffboardingTrackerOutcome_Revoke>): OffboardingTrackerOutcome_Revoke {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ticketId = "";
        if (value !== undefined)
            reflectionMergePartial<OffboardingTrackerOutcome_Revoke>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingTrackerOutcome_Revoke): OffboardingTrackerOutcome_Revoke {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ticket_id */ 1:
                    message.ticketId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingTrackerOutcome_Revoke, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ticket_id = 1; */
        if (message.ticketId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ticketId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.Revoke
 */
export const OffboardingTrackerOutcome_Revoke = new OffboardingTrackerOutcome_Revoke$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerOutcome_Ignore$Type extends MessageType<OffboardingTrackerOutcome_Ignore> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore", []);
    }
    create(value?: PartialMessage<OffboardingTrackerOutcome_Ignore>): OffboardingTrackerOutcome_Ignore {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<OffboardingTrackerOutcome_Ignore>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingTrackerOutcome_Ignore): OffboardingTrackerOutcome_Ignore {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingTrackerOutcome_Ignore, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.Ignore
 */
export const OffboardingTrackerOutcome_Ignore = new OffboardingTrackerOutcome_Ignore$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerOutcome_RelatedObjectDeleted$Type extends MessageType<OffboardingTrackerOutcome_RelatedObjectDeleted> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted", []);
    }
    create(value?: PartialMessage<OffboardingTrackerOutcome_RelatedObjectDeleted>): OffboardingTrackerOutcome_RelatedObjectDeleted {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<OffboardingTrackerOutcome_RelatedObjectDeleted>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingTrackerOutcome_RelatedObjectDeleted): OffboardingTrackerOutcome_RelatedObjectDeleted {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingTrackerOutcome_RelatedObjectDeleted, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerOutcome.RelatedObjectDeleted
 */
export const OffboardingTrackerOutcome_RelatedObjectDeleted = new OffboardingTrackerOutcome_RelatedObjectDeleted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OffboardingTrackerRef$Type extends MessageType<OffboardingTrackerRef> {
    constructor() {
        super("c1.api.offboarding.v1.OffboardingTrackerRef", [
            { no: 1, name: "offboarding_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<OffboardingTrackerRef>): OffboardingTrackerRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.offboardingTicketId = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<OffboardingTrackerRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OffboardingTrackerRef): OffboardingTrackerRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string offboarding_ticket_id */ 1:
                    message.offboardingTicketId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 4:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OffboardingTrackerRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string offboarding_ticket_id = 1; */
        if (message.offboardingTicketId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.offboardingTicketId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 4; */
        if (message.appUserId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.offboarding.v1.OffboardingTrackerRef
 */
export const OffboardingTrackerRef = new OffboardingTrackerRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.offboarding.v1.Offboarding
 */
export const Offboarding = new ServiceType("c1.api.offboarding.v1.Offboarding", [
    { name: "ListOffboardingTrackers", options: { "authz.method": { role: "VIEWER" } }, I: ListOffboardingTrackersRequest, O: ListOffboardingTrackersResponse },
    { name: "GetOffboardingTracker", options: { "authz.method": { role: "VIEWER" } }, I: GetOffboardingTrackerRequest, O: GetOffboardingTrackerResponse },
    { name: "MutateOffboardingTracker", options: { "authz.method": { role: "EDITOR" } }, I: MutateOffboardingTrackerRequest, O: MutateOffboardingTrackerResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.offboarding.v1.OffboardingSearchService
 */
export const OffboardingSearchService = new ServiceType("c1.api.offboarding.v1.OffboardingSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: OffboardingSearchRequest, O: OffboardingSearchResponse }
]);
